<template>
  <div>
    <tic></tic>
  </div>
</template>

<script>
import Tic from "../components/tic";

export default {
  name: "Tic.container",
  components: { Tic }
};
</script>

<style scoped></style>
